import Box from '@zenbusiness/zui/Box';
import IconButton from '@zenbusiness/zui/IconButton';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const BannerRoot = superstyled({
  name: 'AnonymousBanner',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    background:
      'linear-gradient(270deg, rgba(189, 247, 255, 0.25) 0%, rgba(134, 175, 254, 0.25) 50%, rgba(255, 255, 255, 0.25) 100%)',
    padding: theme.spacing(2, 4),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    position: 'relative',
    textAlign: 'center',
    flexDirection: 'row'
  })
});

export const BannerText = superstyled({
  name: 'AnonymousBanner',
  slot: 'Text',
  styles: () => ({})
});

export const CreateAccountLink = superstyled({
  name: 'AnonymousBanner',
  slot: 'CreateAccountLink',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.info.main,
    fontWeight: 600,
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      opacity: 0.9
    }
  })
});

export const CloseButton = superstyled({
  name: 'AnonymousBanner',
  slot: 'CloseButton',
  tag: IconButton,
  styles: ({ theme }) => ({
    padding: theme.spacing(0.5),
    position: 'absolute',
    right: theme.spacing(2),
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)'
    },
    [theme.breakpoints.down('sm')]: {
      right: theme.spacing(1)
    }
  })
});
